import React, { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { BuilderProduct, Project, actions as builderActions } from "@/store/builderSlice";
import { ProductPlacementType } from "@/utils/builder/builderConstants";
import { getBuilderProductData } from "@/store/builder/thunks/builderProductsLoader";
import { loadProject } from "@/store/builder/thunks/projectSaveThunk";
import { fetchRoomModels } from "@/store/builder/thunks/roomModelsThunk";
import { getUserId } from "@/utils/builder/userUtils";


const useProjectLoader = (projectId?: string, isCreateRoomFlow?: boolean, currentRole?: any) => {
    const dispatch = useDispatch();

    const createColorAssets = (project: Project) => {
        const colorHexCodes = [];
        project.surfaceGroups.forEach(surfaceGroup => {
            surfaceGroup.surfaces.forEach(surface => {
                surface.products.map((placement) => {
                    if (placement.type === ProductPlacementType.Color)
                        dispatch(builderActions.addWallTextureColorContent({
                            texture: {
                                id: placement.productId,
                                name: placement.productId,
                                hexCode: placement.productId,
                                type: 'color',
                                surfaceType: surfaceGroup.surfaceType
                            }
                        }));
                });
            });
        });
    }

    const loadUsedProducts = async (products: BuilderProduct[]) => {
        //TODO : should load used products with products by id api
        const productsData = await getBuilderProductData({});
        dispatch(builderActions.addProductData({
            products: productsData
        }));
        console.log('project products loaded....');
    }

    const initUIMetadata = async (metaData: { [key: string]: string }) => {
        dispatch(builderActions.updateDesignData({
            styleName: metaData.styleName,
            designId: metaData.designId
        }));
    }
    const updateUrlParams = (project: Project, currentRole: any) => {
        // const meta = project?.metaData;
        // const params = {
        //     ...(meta?.showcase && { showcase: "true" }),
        //     ...(meta?.interiorDesigner && { interiorDesigner: "true", projectId: project?.projectId }),
        //     ...(meta?.designShowcase && { designShowcase: "true" }),
        // };
        // dispatch(builderActions.setUrlParams({ urlParams: params }));
    };
    
    useEffect(() => {
        if (projectId) {
            dispatch(builderActions.toggleProjectLoading(true))
            loadProject({ projectId, currentRole }).then((project: Project) => {
                createColorAssets(project);
                loadUsedProducts(project.products);
                initUIMetadata(project.metaData)
                updateUrlParams(project, currentRole)
                dispatch(builderActions.initProject({
                    project
                }));
            dispatch(builderActions.toggleProjectLoading(false))
                dispatch(fetchRoomModels({ customerId: getUserId(), isCreateRoomFlow: isCreateRoomFlow ? isCreateRoomFlow : false, showcase: false }) as any);
                console.log('project initialized....');
                console.log(projectId, project);
            })
        }
    }, [])
}
export default useProjectLoader;